<template>
	<a-modal :title="$t('studentsCom.reportCourseNotCompleted')" :width="650" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null"
		:pagination="false">
		<div class="ftr-1 cl-black">
			<div class="cl-info">
				{{$t('studentsCom.situationDescription')}}
			</div>
			<div class="mt-4">
				<!-- *為什麼你的課程未完成? -->
				{{$t('studentsCom.whyNotCompleted')}}
			</div>
			<select class="form-select mt-3" aria-label="Default select example" v-model="info.reason">
			    <option selected>{{$t('common.select')}}</option>
			    <option value="没有时间">没有时间</option>
			    <option value="计划改变">计划改变</option>
			    <option value="与老师协商退款">与老师协商退款</option>
			    <option value="4">日语</option>
			</select>
			<div class="mt-4">
				<!-- *你的预期解决方案是什麼? -->
				{{$t('studentsCom.solution')}}
			</div>
			<select class="form-select mt-2" aria-label="Default select example" v-model="info.expected_result">
			    <option selected>{{$t('common.select')}}</option>
			    <option value="无">无</option>
			    <option value="其他">其他</option>
			</select>
			<div class="mt-4">
				<!-- 解釋和證明 -->
				{{$t('studentsCom.explanation')}}
			</div>
			<div class="cl-info">
				<!-- 如果你有任何證據支持你的請求，請盏可能多的提供，以得最佳结果 -->
				{{$t('studentsCom.explanationContent')}}
			</div>
			<textarea class="mt-3 border-gray wid-100 p-2 br4" v-model="info.content"
			style="height: 150px;" :placeholder="$t('common.enter')"></textarea>
			
			<div class="mt-3 border-gray wid-100 text-center py-2">
				<!-- 上傳最多5張圈片或影片作為證明 -->
				{{$t('studentsCom.uploadImage')}}
			</div>
			<div class="mt-3">
				<upload-img-list v-model="info.files" :num="5"></upload-img-list>
			</div>
			<div class="mt-4 d-flex justify-content-center">
				<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()"> {{$t('common.cancel')}} </button>
				<button type="button" class="btn btn-theme ml16 px-4" @click="createException()">{{$t('common.confirm')}}</button>
			</div>
		</div>
	</a-modal>
</template>

<script>
	import uploadImgList from '../../../components/upload/list.vue'
	export default {
		components:{
			uploadImgList
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			order_id:{
				type: Number,
				default: 0,
			}
		},
		data() {
			return {
				codeLoading: false,
				account: '',
				info:{
					order_id:0,
					reason:'',
					expected_result:'',
					content:'',
					files:[]
				}
			}
		},
		created() {
	
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
			createException(){
				this.info.order_id = this.order_id
				this.$http.api('reservation/createException',this.info).then(res=>{
					this.$message.success(this.$t('common.operationSuccessful'),1,()=>{
						this.$emit('confirm')
					})
				})
			}
		}
	}
</script>

<style>
</style>